import { Components, Theme, alpha } from "@mui/material/styles"

import { neutral, red } from "@constants/colors"
import { defaultTransition } from "@constants/transitions"

export const muiIconButton = ({
  darkMode,
}: {
  darkMode: boolean
}): Components<Omit<Theme, "components">>["MuiIconButton"] => {
  return {
    defaultProps: {
      disableRipple: true,
      disableTouchRipple: true,
      disableFocusRipple: true,
    },
    styleOverrides: {
      root: ({ theme }) => ({
        fontSize: "1rem", //16px
        lineHeight: "1rem", //16px
        borderRadius: theme.shape.borderRadius * 0.75, // 6px
        padding: theme.spacing(0.5),
        minWidth: theme.spacing(3),
        height: theme.spacing(3),
        width: theme.spacing(3),
        whiteSpace: "nowrap",
        gap: theme.spacing(1),
        transition: defaultTransition(theme),
        background: "transparent",
        boxShadow: "none",
        border: "1px solid transparent",
        color: theme.palette.text.secondary,

        "& .MuiSvgIcon-root, & svg": {
          fontSize: "1em!important",
          width: "1em!important",
          height: "1em!important",
          stroke: "currentColor",
        },

        "&:hover": {
          background: darkMode
            ? alpha(neutral.white, 0.1)
            : alpha(neutral.black, 0.05),
        },

        "&:active": {
          background: darkMode
            ? alpha(neutral.white, 0.05)
            : alpha(neutral.black, 0.1),
        },

        "&.Mui-disabled": {
          opacity: 1,
          background: "transparent",
          border: "1px solid transparent!important",
          boxShadow: "none",
          color: theme.palette.text.disabled,

          "& .MuiSvgIcon-root, & svg, & .MuiBox-root": {
            opacity: "inherit",
            color: "inherit",
            stroke: "currentColor",
          },
        },

        variants: [
          {
            props: { color: "error" },
            style: {
              "&:hover": {
                color: red[500],
                "& .MuiSvgIcon-root, & svg, & .MuiBox-root": {
                  color: red[500],
                  stroke: "currentColor",
                },
              },
              "&:active": {
                color: red[700],
                "& .MuiSvgIcon-root, & svg, & .MuiBox-root": {
                  color: red[700],
                  stroke: "currentColor",
                },
              },
            },
          },
        ],
      }),
    },
  }
}
